// ===================================
// INTERVIEW API SERVICE - STAGE 6 UPDATE
// src/services/interviewApi.js
// Enhanced with context and hint endpoints
// ===================================

import api from './api';

/**
 * Get full interview context including resume and JD
 */
export const getInterviewContext = async (sessionId) => {
  const response = await api.get(`/interview/${sessionId}/context`);
  return response.data;
};

/**
 * Start an interview session
 */
export const startInterview = async (sessionId) => {
  const response = await api.post('/interview/start', { sessionId });
  return response.data;
};

/**
 * Send a message and get AI response
 */
export const sendMessage = async (sessionId, message, conversationHistory = []) => {
  const response = await api.post('/interview/message', {
    sessionId,
    message,
    conversationHistory
  });
  return response.data;
};

/**
 * Get a realtime feedback hint (if enabled)
 */
export const getHint = async (sessionId, userMessage, question) => {
  const response = await api.post('/interview/hint', {
    sessionId,
    userMessage,
    question
  });
  return response.data;
};

/**
 * End the interview and get evaluation
 */
export const endInterview = async (sessionId, conversationHistory = []) => {
  const response = await api.post('/interview/end', {
    sessionId,
    conversationHistory
  });
  return response.data;
};

/**
 * Get interview status with remaining time
 */
export const getInterviewStatus = async (sessionId) => {
  const response = await api.get(`/interview/${sessionId}/status`);
  return response.data;
};

/**
 * Get suggested questions for this session type
 */
export const getSessionQuestions = async (sessionId) => {
  const response = await api.get(`/interview/${sessionId}/questions`);
  return response.data;
};

export default {
  getInterviewContext,
  startInterview,
  sendMessage,
  getHint,
  endInterview,
  getInterviewStatus,
  getSessionQuestions
};
